import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';

export default function CloseIcon({ onClose }: { onClose: () => void }) {
    return (
        <Box
            onClick={onClose}
            sx={{
                position: 'absolute',
                display: 'flex',
                p: 0.625,
                right: 0,
                top: 0,
                cursor: 'pointer',
                '&:hover': {
                    color: 'primary.main',
                },
            }}
        >
            <IconMi icon={'times'} />
        </Box>
    );
}
